class TemplateManager {

    constructor() {
        this._templates = {};

        document.querySelectorAll('template').forEach(node => {
            this._templates[node.id] = node.content;
        });
    }

    get(template = '') {
        if( template in this._templates )
        {
            return document.importNode( this._templates[template], true );
        }

        if( template.length )
        {
            // search document again if template exists
            let fragment = document.querySelector('template[id="' + template + '"]');

            if( fragment )
            {
                this._templates[template] = fragment.content;

                return fragment.importNode( fragment, true );
            }
        }

        return document.createDocumentFragment();
    }
}

const manager = new TemplateManager;

export default manager